import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { checkIsActive } from "../../../helpers";

const SidebarMenuItem = ({ to, title, icon }) => {
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to);
  
  return (
    <li className={`nav-item ${isActive && "active"}`}>
      <Link className="nav-link" to={to}>
        <FontAwesomeIcon icon={icon} fixedWidth size="xs" className="me-1" />
        <span>{title}</span>
      </Link>
    </li>
  );
};

export { SidebarMenuItem };
